import {
    ADD_HEATMAP,
    CHANGE_HEATMAP_DISPLAY,
    DELETE_HEATMAPS,
    FETCH_HEATMAPS,
    MAP_LOADED,
    MAP_ERROR,
    CHANGE_LAYER
} from "../../actions/heatmaps";

const initialState = {
    list: [],
    display: null,
    loaded:0,
    loading:true,
    porcent:0,
    total:0,
    error: false,
};

const heatmaps = (state = initialState, action) => {
    switch (action.type) {
        case ADD_HEATMAP:
            return {
                ...state,
                list: [
                    ...state.list,
                    {
                        ...action.heatmap
                    }
                ],
                display: action.heatmap
            }
        case FETCH_HEATMAPS:

            let total = 0;

            total = action.heatmaps.length;

            return {
                ...state,
                loading:true,
                list: action.heatmaps,
                display: action.heatmaps[action.heatmaps.length - 1],
                total: total,
                error: false,
            }

        case DELETE_HEATMAPS:
            return initialState

        case CHANGE_HEATMAP_DISPLAY:
            return {
                ...state,
                display: state.list[action.position]
            }

        case MAP_LOADED:
            let totalLoaded = state.loaded+1;
            let isLoading = true;

            let porcent = Math.round(totalLoaded*100/state.total);

            if(totalLoaded >= state.total-1)
                isLoading=false;

            // let porcent = Math.round(totalLoaded*100/5);
            //
            // if(totalLoaded >= 5)
            //     isLoading=false;

            return {
                ...state,
                loading: isLoading,
                loaded: totalLoaded,
                porcent: porcent
            };

        case MAP_ERROR:
            return {
                ...state,
                error: true
            };

        default:
            return state
    }
}


export default heatmaps



// WEBPACK FOOTER //
// ./src/reducers/map/heatmaps.js